import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import GrabCentsDocs from '../../../../documentation/GrabCentsDocumentation';
import DualValueListInput from '../../../../../../atomic/inputs/dualValueListInput/DualValueListInput';
import { colors } from '../../../../../../../colorVars';
import { UnitIndicator } from '../../../../../../atomic/formElements/unitIndicator/UnitIndicator';

function GrabCentsModule({ state }) {
  const [
    grabCents,
    dispatchGrabCents,
    , 
    setGrabCentsEnabled,
    grabCentsMode,
    setGrabCentsMode,
  ] = state;
  const stringDecToPercentString = (decString) => {
    const percent = Number(decString) * 100;
    return percent.toString();
  };
  const arrayToStringList = (arr) => {
    return arr.join(',');
  };
  const [trailPctDisplay, setTrailPctDisplay] = useState('');
  const [trailQtyDisplay, setTrailQtyDisplay] = useState('');
  const [trailAmountDisplay, setTrailAmountDisplay] = useState('');

  const resetArrays = () => {
    dispatchGrabCents({ centsPerLevel: '' });
    dispatchGrabCents({ percentagePerLevel: [] });
    dispatchGrabCents({ quantityPerLevel: [] });
  };

  useEffect(() => {
    setGrabCentsEnabled(true);
  }, []);

  useEffect(() => {
    setTrailPctDisplay(stringDecToPercentString(grabCents.trailPercent));
    setTrailQtyDisplay(grabCents.trailQuantity);
    setTrailAmountDisplay(
      grabCents.takeProfitMode === 'DOLLARS'
        ? Number(grabCents.trailAmount).toFixed(2).toString()
        : Number(grabCents.trailAmount) * 100
    );
  }, [grabCents]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={GrabCentsDocs} /> Grab Cents
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <div className={style.horizontalLabelAndSelect}>
            <p className={style.labelAndIndicator}>
              <UnitIndicator
                margin="0 3px 0 0"
                height={12}
                width={12}
                color={
                  grabCents.takeProfitMode === 'DOLLARS'
                    ? colors.green
                    : colors.orange
                }
              />
              Profit Unit
            </p>
            <select
              value={grabCents.takeProfitMode}
              onChange={({ target }) => {
                dispatchGrabCents({ takeProfitMode: target.value });
                resetArrays();
              }}
            >
              <option value="DOLLARS">Dollars</option>
              <option value="PERCENT">Percentage</option>
            </select>
          </div>
          <div className={style.horizontalLabelAndSelect}>
            <p className={style.labelAndIndicator}>
              <UnitIndicator
                margin="0 3px 0 0"
                height={12}
                width={12}
                color={
                  grabCentsMode === 'percentage'
                    ? colors.orange
                    : colors.blue
                }
              />
              Qty. Unit
            </p>
            <select
              value={grabCentsMode}
              onChange={({ target }) => {
                setGrabCentsMode(target.value);
                resetArrays();
              }}
            >
              <option value="percentage">Percentage</option>
              <option value="quantity">Quantity</option>
            </select>
          </div>
        </div>
        {grabCentsMode === 'percentage' ? (
          <>
            <div
              className={style.inputAndLabel}
              style={{ gridColumn: 'span 2' }}
            >
              <p className={style.flexSpread}>
                <span>Profit</span> <span>| Quantity </span>
              </p>
              <DualValueListInput
                symbol1={grabCents.takeProfitMode === 'DOLLARS' ? '$' : '%'}
                symbol2="%"
                direction1={
                  grabCents.takeProfitMode === 'DOLLARS' ? 'left' : 'right'
                }
                direction2="right"
                onAddDelete={(valueList) => {
                  dispatchGrabCents({
                    centsPerLevel: arrayToStringList(
                      valueList.map((item) => {
                        if (grabCents.takeProfitMode === 'DOLLARS')
                          return item[0];
                        else return Number(item[0]) / 100;
                      })
                    ),
                  });
                  dispatchGrabCents({
                    percentagePerLevel: valueList.map((item) => item[1] / 100),
                  });
                }}
                currentValues1={grabCents.centsPerLevel || []}
                currentValues2={grabCents.percentagePerLevel || []}
                type1={
                  grabCents.takeProfitMode === 'DOLLARS'
                    ? 'decimal'
                    : 'percentageArray'
                }
                type2="percentageArray"
                buttonColor={colors.white}
                buttonBgColor={colors.blue}
              />
            </div>
            <div className={style.inputAndLabel}>
              <p>Trail Qty.</p>
              <NumberInputWithUnit
                direction="right"
                type="number"
                value={trailPctDisplay}
                setValue={setTrailPctDisplay}
                onBlur={(value) =>
                  dispatchGrabCents({ trailPercent: Number(value) / 100 })
                }
              >
                %
              </NumberInputWithUnit>
            </div>
          </>
        ) : (
          <>
            <div
              className={style.inputAndLabel}
              style={{ gridColumn: 'span 2' }}
            >
              <p className={style.flexSpread}>
                <span>Profit</span> <span>| Quantity </span>
              </p>
              <DualValueListInput
                symbol1={grabCents.takeProfitMode === 'DOLLARS' ? '$' : '%'}
                symbol2="#"
                direction1={
                  grabCents.takeProfitMode === 'DOLLARS' ? 'left' : 'right'
                }
                direction2="left"
                onAddDelete={(valueList) => {
                  dispatchGrabCents({
                    centsPerLevel: arrayToStringList(
                      valueList.map((item) => {
                        if (grabCents.takeProfitMode === 'DOLLARS')
                          return item[0];
                        else return Number(item[0]) / 100;
                      })
                    ),
                  });
                  dispatchGrabCents({
                    quantityPerLevel: valueList.map((item) => item[1]),
                  });
                }}
                type1={
                  grabCents.takeProfitMode === 'DOLLARS'
                    ? 'decimal'
                    : 'percentageArray'
                }
                type2="integer"
                currentValues1={grabCents.centsPerLevel || []}
                currentValues2={grabCents.quantityPerLevel || []}
                buttonColor={colors.white}
                buttonBgColor={colors.blue}
              />
            </div>
            <div className={style.inputAndLabel}>
              <p>Trail Qty.</p>
              <NumberInputWithUnit
                direction="left"
                type="number"
                value={trailQtyDisplay}
                setValue={setTrailQtyDisplay}
                onBlur={(value) => dispatchGrabCents({ trailQuantity: value })}
              >
                #
              </NumberInputWithUnit>
            </div>
          </>
        )}
        <div className={style.inputAndLabel}>
          <p>Trail Distance</p>
          <NumberInputWithUnit
            direction={
              grabCents.takeProfitMode === 'DOLLARS' ? 'left' : 'right'
            }
            type="number"
            value={trailAmountDisplay}
            setValue={setTrailAmountDisplay}
            onBlur={(value) =>
              dispatchGrabCents({
                trailAmount:
                  grabCents.takeProfitMode === 'DOLLARS'
                    ? value
                    : Number(value) / 100,
              })
            }
          >
            {grabCents.takeProfitMode === 'DOLLARS' ? '$' : '%'}
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
GrabCentsModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default GrabCentsModule;
